import './eligibility-details.scss';
import { useMemo } from 'react'
import { TextInfo } from '../../../../text'
import { ApplicationStep1 } from '../../../../../models/classes/ApplicationStep1.class'
import { ChangeOwnershipReasonCode } from '../../../../../utils/code-converter'
import { ReasonEnum } from '../../../../../models/enum/reason.enum'
import { OwnershipReasonEnum } from '../../../../../models/enum/ownership-reason.enum'
import { Helpers } from '../../../../../utils/helper'
import { Radio_Cpf_Refund, Radio_Has_Outstanding_Loan, Radio_Submit_Consent } from '../../../../../utils/shared-radio'
import { DemiseCurrentOwner } from '../../../../../utils/shared-dropdown'

interface EligibilityDetailsInterface {
  details: ApplicationStep1
}

const EligibilityDetails = ({ ...props }: EligibilityDetailsInterface) => {



  const isChangeOfMaritalStatus = useMemo(() => {
    return props.details.reason.reason === ReasonEnum.marital_status_reason_value;
  }, [props.details.reason.reason])

  const isDivorce = useMemo(() => {
    return isChangeOfMaritalStatus && props.details.reason.change_ownership_reason === OwnershipReasonEnum.divorce;
  }, [isChangeOfMaritalStatus, props.details.reason.change_ownership_reason])

  const hasDOM = useMemo(() => {
    return isChangeOfMaritalStatus && (props.details.reason.change_ownership_reason === OwnershipReasonEnum.moving_out_due_to_marriage || props.details.reason.change_ownership_reason === OwnershipReasonEnum.inclusion_due_to_marriage || props.details.reason.change_ownership_reason === OwnershipReasonEnum.moving_out_others);
  }, [isChangeOfMaritalStatus, props.details.reason.change_ownership_reason])

  const hasFinalJudgement = useMemo(() => {
    return props.details.reason.have_final_judgement === 'yes';
  }, [props.details.reason.have_final_judgement])

  const hasDOD = useMemo(() => {
    return !!props.details.reason.death_date;
  }, [props.details.reason.death_date])


  const isRenunciation = useMemo(() => {
    return props.details.reason.reason === ReasonEnum.loss_of_citizenship_reason_value;
  }, [props.details.reason.reason])


  const isFinancialCircumstances = useMemo(() => {
    return props.details.reason.reason === ReasonEnum.financial_circumstances_reason_value;
  }, [props.details.reason.reason])


  const hasOutstandingLoan = useMemo(() => {
    return props.details.reason.has_outstanding_loan === "yes";
  }, [props.details.reason.has_outstanding_loan])





  return (
    <div className='polymer-eligibility-details'>
      {/* eg: COR1 */}
      <TextInfo variant='column' title={`Reason for change of ownership`} description={ChangeOwnershipReasonCode.find(e => e.change_ownership_reason_value === props.details.reason.change_ownership_reason)?.label} />

      {isChangeOfMaritalStatus && <TextInfo variant='column' title={`Which of the following best describes your situation?`} description={ChangeOwnershipReasonCode.find(e => e.reason_value === props.details.reason.reason)?.hdb_description} />}

      {isDivorce && <TextInfo variant='column' title={`Do you have a Final Judgement/Certificate of Divorce?`} description={hasFinalJudgement ? "Yes" : "No"} />}
      
      {props.details.reason.final_judgement_date 
      && <TextInfo variant='column' title={`Please input the Final Judgement/Certificate of Divorce date`} description={Helpers.formatDate(props.details.reason.final_judgement_date)} />}

      {props.details.reason.date_of_court_order 
      && <TextInfo variant='column' title={`Please input the due date to complete the Change in Flat Ownership as shown in the Court Order`} description={Helpers.formatDate(props.details.reason.date_of_court_order)} /> }
      
      {props.details.reason.amount_stated_in_court_order 
      && <TextInfo variant='column' title={`Please indicate the cash consideration amount stated in the Court Order`} description={(props.details.reason.amount_stated_in_court_order)} /> }
      
      {props.details.reason.cpf_refund 
      && <TextInfo variant='column' title={`CPF refund to outgoing owner`} description={Radio_Cpf_Refund.find(e => e.value === props.details.reason.cpf_refund)?.description} />}
      
      {props.details.reason.submit_content 
      && <TextInfo variant='column' title={`I confirm that all current and proposed owners are willing to login via SingPass to submit their consent for this application and attend the completion appointment in person.`} description={Radio_Submit_Consent.find(e => e.value === props.details.reason.submit_content)?.description} /> }
      
      {props.details.reason.death_date 
      && <TextInfo variant='column' title={`Date of death`} description={Helpers.formatDate(props.details.reason.death_date)} />}

      {props.details.reason.is_beneficiary_proposed_owners 
      && <TextInfo variant='column' title={`Are all the beneficiaries listed in the Will or Intestate Succession Act also the proposed owners?`} description={DemiseCurrentOwner.beneficiariesProposedOwners.find(e => e.value === props.details.reason.is_beneficiary_proposed_owners)?.description} />}

      {props.details.reason.date_of_marriage 
      && <TextInfo variant='column' title={`Date of marriage`} description={Helpers.formatDate(props.details.reason.date_of_marriage)} />}
      
      {props.details.reason.date_of_renunciation 
      && <TextInfo variant='column' title={`Date of renunciation`} description={Helpers.formatDate(props.details.reason.date_of_renunciation)} />}

      {props.details.reason.has_outstanding_loan 
      && <TextInfo variant='column' title={`Do you currently have any outstanding loan or outstanding upgrading costs?`} description={Radio_Has_Outstanding_Loan.find(e => e.value === props.details.reason.has_outstanding_loan)?.description} />}

      {props.details.reason.outstanding_loan_amount 
      && <TextInfo variant='column' title={`Please indicate your outstanding loan amount?`} description={Helpers.amountToTwoDecimals(props.details.reason.outstanding_loan_amount)} />}

    </div>
  )
}

export default EligibilityDetails